<!--
 * @Description: 
 * @Autor: Sia
 * @Date: 2020-01-19 10:47:00
 * @LastEditors  : Sia
 * @LastEditTime : 2020-01-19 14:00:09
 -->
<template>
  <!-- 标题 高级筛选 -->
  <div class="bg-shadow flex-wrap el-tabs__content">
    <!-- 表格 -->
    <div style="position: relative" class="graph-table">
      <div class="table_min" v-if="page.isTableKey" v-loading="loading.tableLoading" element-loading-background="#FFF"
        element-loading-spinner="el-icon-loading" element-loading-customClass="defineLoading"
        element-loading-text="拼命的加载中">
        <nofill-table :tableInfo="tableInfo" class="block-preview">
          <pagination :loading="loading.page" :page-num="{ num: tableInfo.pageNum }" :page-total="tableInfo.count">
          </pagination>
        </nofill-table>
      </div>
    </div>
  </div>
</template>

<script>
  import * as queryUtil from "../../../common/query";
  import * as Func from "../../../common/commonFun";
  import nofillTable from "../../../components/query/common/nofill-table ";
  import Pagination from "../../../components/query/common/pageination";

  import { content } from "./component";
  export default {
    components: {
      ...content,
      nofillTable,
      Pagination
    },
    props: {
      page: [Object],
      headerVal: [Object],
      header: [Object],
      headerShow: [Array]
    },
    data() {
      return {
        loading: {
          tableLoading: false
        },
        // 表格
        tableInfo: {}
      };
    },
    created() { },
    computed: {
      // 公共数据
      queryCommon() {
        return this.$store.state.query_common;
      },
      queryTable() {
        let a = Object.assign(
          {},
          this.$store.state.query_common,
          this.$store.state.query_table
        );
        let b = {
          startTime: a.startTime,
          endTime: a.endTime,
          storeID: a.storeID,
          pageNum: a.pageNum,
          pageSize: a.pageSize,
          storeIDs: a.storeIDs, // 加上参数
        };
        this.getTable(b);
        return b;
      }
    },
    watch: {
      queryTable(v) {
        // this.getTable(v);
      }
    },
    methods: {
      getTable(params) {
        // console.log(params);
        if (
          this.$route.name === this.page.name &&
          params.startTime !== undefined
        ) {
          Func.getNoRechargeTable(this, params);
        }
      }
    }
  };
</script>

<style lang="less"></style>